import React from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import colors from "../../assets/theme/colors";

const TopBarShell = ({
  left,
  center,
  right,
  toolbarSx = {},
  leftSx = {},
  centerSx = {},
  rightSx = {},
  appBarSx = {},
  showShadow = true,
  children = null,
}) => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "rgba(255,255,255,0.94)",
        color: colors.landing.heroText,
        backgroundImage: "none",
        boxShadow: showShadow ? "0 6px 18px rgba(15, 23, 42, 0.05)" : "none",
        borderBottom: `1px solid ${colors.landing.borderSoft}`,
        pt: "env(safe-area-inset-top)",
        ...appBarSx,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: "calc(56px + env(safe-area-inset-top))",
          px: { xs: 1.25, sm: 2 },
          py: 0.5,
          ...toolbarSx,
        }}
      >
        {children || (
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: "auto 1fr auto",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box sx={{ minWidth: 0, ...leftSx }}>{left}</Box>
            <Box sx={{ minWidth: 0, textAlign: "center", ...centerSx }}>{center}</Box>
            <Box sx={{ minWidth: 0, display: "flex", justifyContent: "flex-end", ...rightSx }}>{right}</Box>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopBarShell;
